import { IEReservationIntervalDateGroup } from "modules/appointment/types/IEReservationIntervalDateGroup";
import { IntervalElementStatus } from "modules/appointment/types/IntervalElementStatus";

import { DateObject, DateObjectType } from "utils/DateObject";

import { Calendar } from "components/Calendar";

interface IProps {
  date: DateObjectType | null;
  reservationIntervalList: IEReservationIntervalDateGroup[];
  setDate: (date: DateObjectType | null) => void;
  setMonth: (date: DateObjectType | null) => void;
}

const ReservationCalendar = ({
  date,
  setDate,
  setMonth,
  reservationIntervalList,
}: IProps) => {
  const today = DateObject();

  const setDatePicker = (date: Date | null) => {
    setDate(date ? DateObject(date) : null);
  };

  const handleMonthChange = (date: Date) => {
    setMonth(DateObject(date));
    setDate(null);
  };

  return (
    <Calendar
      id="reservation-calendar"
      value={date ? date.toDate() : null}
      minDate={today.toDate()}
      onMonthChange={handleMonthChange}
      onChange={setDatePicker}
      disabledDay={(date) =>
        !reservationIntervalList.find(
          (group) =>
            group.date.baseFormat() === DateObject(date).baseFormat() &&
            group.intervals.find(
              (interval) => interval.status === IntervalElementStatus.Available
            )
        )
      }
    />
  );
};

export { ReservationCalendar };
